import styled from "styled-components";
import Text from "antd/es/typography/Text";

export const DisclaimerText = styled(Text)`
  font-size: 14px;
`;
